import { FC } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

type Props = {
  title: string;
  evento?: any;
  styles?: object;
  icono: Icons.IconName;
};

const Rol: FC<Props> = ({ title, evento, styles, icono }) => {
  return (
    <div key={Math.random()} onClick={evento} className="contenerdor-menu-item">
      <p className="text-center mt-5">
        <span className="menu-icon">
          <FontAwesomeIcon icon={icono} size="3x" />
        </span>
      </p>
      <p className="text-center ">
        <a key={Math.random()} href="/">
          {title}
        </a>
      </p>
    </div>
  );
};

export { Rol };
